import axios from "@/plugins/axios";

export default {
    findById(approachId) {
        return axios.httpApi.get("/approach/" + approachId);
    },
    save(data) {
        data = JSON.parse(JSON.stringify(data));
        delete data.creditor;
        delete data.approach;
        delete data.updated_at;
        delete data.created_at;
        delete data.strategies;
        delete data.uses;

        if (data.id) {
            return axios.httpApi.patch("/approach/" + data.id, data);
        }

        return axios.httpApi.post("/approach", data);
    },
    delete(approachId) {
        return axios.httpApi.delete("/approach/" + approachId);
    },
    list(creditor_id, pagination, active = false, types = [], nameFilter = null) {
        let params = {}

        if (creditor_id) {
            params.creditor = creditor_id
        }

        if (nameFilter && nameFilter.length > 0) {
            params.text = nameFilter;
        }

        if (types.length)
            params.types = types.map((sp) => sp).join(",");

        // if (this.showOnlysUseds) {
        //     params.only_in_strategies = true
        // }

        params.active = active;
        params.page = pagination.page;
        params.limit =
            pagination.rowsPerPage == -1 ? 9999 : pagination.rowsPerPage;

        if (pagination.sortBy)
            params.order =
                (pagination.descending ? "-" : "") + pagination.sortBy;

        return axios.httpApi.get("/approach", { params });
    },
    async listAll(creditorId, active = false) {
        let result = [];
        let loop = true
        let _pagination = {
            rowsPerPage: 500,
            page: 1,
        };

        do {
            let res = await this.list(creditorId, _pagination, active)
            result = result.concat(res.objects);
            _pagination.page++;
            if (res.objects.length < _pagination.rowsPerPage) {
                loop = false
                return {
                    objects: result,
                    totalItems: _pagination.totalItems,
                };
            }
        } while (loop);
    },
    sms(payload, id = 0) {
        let type = "post";
        let plus = "";
        if (id) {
            plus = "/" + id;
            if (payload) type = "patch";
            else type = "delete";
        }
        return axios.httpApi[type]("/sms_messages" + plus, payload);
    },
    email(payload, id = 0) {
        let type = "post";
        let plus = "";
        if (id) {
            plus = "/" + id;
            if (payload) type = "patch";
            else type = "delete";
        }
        return axios.httpApi[type]("/email_messages" + plus, payload);
    },
    push(payload, id = 0) {
        let type = "post";
        let plus = "";
        if (id) {
            plus = "/" + id;
            if (payload) type = "patch";
            else type = "delete";
        }
        return axios.httpApi[type]("/push_messages" + plus, payload);
    },
    whatsapp(payload, id = 0) {
        let type = "post";
        let plus = "";
        if (id) {
            plus = "/" + id;
            if (payload) type = "patch";
            else type = "delete";
        }
        return axios.httpApi[type]("/whatsapp_messages" + plus, payload);
    },
};